import { Card, NoFound } from '@/components/generic';

const Banner = () => {
  return (
    <Card
      classHead='!pl-3'
      title='Banner'
    >
      <div className='px-2 pb-3'>
        <NoFound
          title='Banner'
          sub='Banner info'
        />
      </div>
    </Card>
  );
};

export default Banner;
